// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"a0841970","252":"ab55d4be","480":"14c5af88","563":"dfadd39e","774":"e1ef58e5","787":"921b21c2","866":"cd43dfc2","883":"e717563f"}[chunkId] + ".chunk.js";
};